module.exports = __webpack_public_path__ + "static/media/blockQuote.c9c86324.svg";